import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { Button, CardContent, Grid, TextField, Typography } from '@material-ui/core'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import _ from 'lodash'
import SecondaryViewItemComponent from '../common/SecondaryViewItem.component'

import { updateSSOForEnterpriseDomain, fetchRemoteMetadataForDomain, forceSamlOnEnterpriseUsers } from '../../actions/enterprises'
import i18n from '../../i18n'

const styles = theme => ({
  tabBar: {
    marginBottom: 8
  },
  actions: {
    justifyContent: 'flex-end'
  },
  button: {
    background: '#2ad18b',
    marginBottom: 16,
    textTransform: 'uppercase'
  },
  inlineButton: {
    textTransform: 'uppercase',
    borderRadius: 0,
    width: 120,
    minWidth: 0,
    background: '#2ad18b',
    height: 41,
    marginBottom: 3,
    '&:hover': {
      background: '#3ae19b'
    }
  },
  manualConfigurationButton: {
    justifyContent: 'flex-end'
  },
  inlineTextField: {
    width: 'calc(100% - 120px)'
  },
  multiLineLabel: {
    marginTop: 0
  },
  paragraph: {
    marginTop: 16
  },
  headerSpacer: {
    marginTop: 16
  },
  domainsTableCell: {
    paddingLeft: 8,
    paddingRight: 16,
    '&:last-of-type': {
      paddingRight: 8,
      textAlign: 'center'
    }
  }
})

class EnterpriseManagerSSO extends Component {
  state = {
    domains: [],
    isManualConfigurationOpen: []
  }

  constructor (props) {
    super(props)
    this.classes = props.classes
  }

  componentDidMount = () => {
    const { domains } = this.state
    const isManualConfigurationOpen = { ...this.state.isManualConfigurationOpen }
    if (domains) {
      domains.map((d, i) => {
        if (d.authentication_provider_type === 'SAML') {
          isManualConfigurationOpen[i] = true
        }
        return d
      })
      this.setState({ isManualConfigurationOpen })
    }
  }

  componentWillUnmount = () => {
  }

  handleOnInputChange = (event) => {
    const state = { ...this.state }
    const { target } = event
    _.set(state, target.name, target.value)
    this.setState(state)
  }

  onManualConfigurationToggleClicked = (event, index) => {
    const state = { ...this.state }
    state.isManualConfigurationOpen[index] = !state.isManualConfigurationOpen[index]
    this.setState(state)
  }

  onFetchMetadataClicked = (event, index) => {
    this.props.fetchRemoteMetadataForDomain(index, this.state.domains[index].metadataurl)
      .then(() => {
        this.onManualConfigurationToggleClicked(event, index)
      })
  }

  onSaveClicked = (event, domain, data) => {
    this.props.updateSSOForEnterpriseDomain(this.props.self.user.Enterprise.id, domain.id, data)
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (nextProps.domains) {
      return { domains: nextProps.domains }
    } else {
      return null
    }
  }

  forceSAMLLoginsClicked = (event, domainId) => {
    event.preventDefault()
    if (this.props.enterprise) {
      this.props.forceSamlOnEnterpriseUsers(this.props.self.user.Enterprise.id, domainId)
    }
  }

  renderManualConfigurationForm = (domain, index) => {
    const { classes } = this.props
    return (
      <>
        <TextField
          inputProps={{ }}
          id='providerIssuer'
          name={`domains[${index}].SamlAuthenticationProvider.provider_issuer`}
          defaultValue={domain.SamlAuthenticationProvider ? domain.SamlAuthenticationProvider.provider_issuer : ''}
          onChange={this.handleOnInputChange}
          type='text'
          label={i18n.enterprise.singleSignOn.card.manualConfig.providerIssuerInputLabel}
          margin='normal'
          fullWidth
          required
        />
        <TextField
          inputProps={{ }}
          id='signonServiceUrl'
          name={`domains[${index}].SamlAuthenticationProvider.signon_service_url`}
          defaultValue={domain.SamlAuthenticationProvider ? domain.SamlAuthenticationProvider.signon_service_url : ''}
          onChange={this.handleOnInputChange}
          type='text'
          label={i18n.enterprise.singleSignOn.card.manualConfig.signonServiceUrlInputLabel}
          margin='normal'
          fullWidth
          required
        />
        <TextField
          inputProps={{ }}
          id='logoutServiceUrl'
          name={`domains[${index}].SamlAuthenticationProvider.logout_service_url`}
          defaultValue={domain.SamlAuthenticationProvider ? domain.SamlAuthenticationProvider.logout_service_url : ''}
          onChange={this.handleOnInputChange}
          type='text'
          label={i18n.enterprise.singleSignOn.card.manualConfig.logoutServiceUrlInputLabel}
          margin='normal'
          fullWidth
          required
        />
        <TextField
          InputLabelProps={{ className: classes.multiLineLabel }}
          id='providerCertificate'
          name={`domains[${index}].SamlAuthenticationProvider.provider_certificate`}
          label={i18n.enterprise.singleSignOn.card.manualConfig.providerCertificateInputLabel}
          onChange={this.handleOnInputChange}
          type='text'
          multiline
          rows={5}
          margin='normal'
          fullWidth
          required
        />
        <Grid
          container
          justify='flex-end'
        >
          <Grid
            item
          >
            <Button
              className={classes.button}
              variant='contained'
              size='small'
              color='primary'
              onClick={(e) => { this.onSaveClicked(e, domain, domain.SamlAuthenticationProvider) }}
            >
              {i18n.common.button.save}
            </Button>
          </Grid>
        </Grid>
      </>
    )
  }

  render () {
    const { classes } = this.props
    return (
      <Grid container direction='column'>
        <Grid item>
          <>
            {!this.state.domains &&
              <SecondaryViewItemComponent
                name={i18n.enterprise.singleSignOn.tab}
                description={i18n.enterprise.singleSignOn.desc}
              >
                <CardContent>
                  <Typography variant='body1'>
                    <br />{i18n.enterprise.singleSignOn.noDomain.info}
                  </Typography>
                  <Typography variant='body2'>
                    {i18n.enterprise.singleSignOn.noDomain.instruction}
                  </Typography>
                </CardContent>
              </SecondaryViewItemComponent>}
            {this.state.domains && this.state.domains.map((domain, index) => {
              return (
                <SecondaryViewItemComponent
                  key={index}
                  name={index === 0 ? i18n.enterprise.singleSignOn.tab : ''}
                  description={index === 0 ? i18n.enterprise.singleSignOn.desc : ''}
                >
                  <CardContent>
                    <Typography variant='subtitle1'>{domain.name}</Typography>
                    {domain.is_verified &&
                      <>
                        <Typography variant='body2'>
                          {i18n.enterprise.singleSignOn.card.instruction}
                        </Typography>
                        {!this.state.isManualConfigurationOpen[index] &&
                          <>
                            <TextField
                              className={classes.inlineTextField}
                              inputProps={{ }}
                              id='domainName'
                              name={`domains[${index}].metadataurl`}
                              onChange={this.handleOnInputChange}
                              type='text'
                              label={i18n.enterprise.singleSignOn.card.autoConfig.urlInputLabel}
                              placeholder='e.g. http://mydomain/federationmetadata/2007-06/federationmetadata.xml'
                              margin='normal'
                              required
                            />
                            <Button
                              className={classes.inlineButton}
                              variant='contained'
                              color='primary'
                              onClick={(e) => { this.onFetchMetadataClicked(e, index) }}
                            >
                              {i18n.common.button.fetch}
                            </Button>
                          </>}
                        <Grid container justify='flex-end'>
                          <Grid item>
                            <Button
                              className={classes.manualConfigurationButton}
                              size='small'
                              variant='text'
                              color='primary'
                              onClick={(e) => { this.onManualConfigurationToggleClicked(e, index) }}
                            >
                              {this.state.isManualConfigurationOpen[index] ? i18n.enterprise.singleSignOn.card.autoConfig.button : i18n.enterprise.singleSignOn.card.manualConfig.button}
                            </Button>
                          </Grid>
                        </Grid>

                        {this.state.isManualConfigurationOpen[index] && this.renderManualConfigurationForm(domain, index)}

                        <Typography variant='body1'>{i18n.enterprise.singleSignOn.card.metadataDoc.title}</Typography>
                        <Typography variant='body2'>
                          {i18n.enterprise.singleSignOn.card.metadataDoc.desc}
                        </Typography>
                        <TextField
                          InputProps={{
                            readOnly: true
                          }}
                          className={classes.inlineTextField}
                          fullWidth
                          defaultValue={`${process.env.REACT_APP_IDENTITY_API_HOST}/auth/saml/${domain.id}/metadata`}
                          margin='normal'
                        />
                        <CopyToClipboard
                          text={`${process.env.REACT_APP_IDENTITY_API_HOST}/auth/saml/${domain.id}/metadata`}
                        >
                          <Button
                            className={classes.inlineButton}
                            variant='contained'
                            color='primary'
                            onClick={(e) => { }}
                          >
                            {i18n.common.button.copy}
                          </Button>
                        </CopyToClipboard>

                        <Typography variant='body1' className={classes.headerSpacer}>{i18n.enterprise.singleSignOn.card.forceSamlLogins.title}</Typography>
                        <Grid
                          container
                          direction='row'
                          alignItems='center'
                          justify='space-between'
                        >
                          <Grid item xs={12} md={8}>
                            <Typography variant='body2'>
                              {i18n.formatString(i18n.enterprise.singleSignOn.card.forceSamlLogins.desc, { domainName: domain.name })}
                            </Typography>
                          </Grid>
                          <Grid item xs md={4}>
                            <Button
                              variant='text'
                              color='primary'
                              onClick={(e) => { this.forceSAMLLoginsClicked(e, domain.id) }}
                            >
                              {i18n.enterprise.singleSignOn.card.forceSamlLogins.button}
                            </Button>
                          </Grid>
                        </Grid>
                      </>}
                    {!domain.is_verified &&
                      <Typography variant='body2'>
                        {i18n.enterprise.singleSignOn.card.verifiedInfo}
                      </Typography>}
                  </CardContent>
                </SecondaryViewItemComponent>
              )
            })}
          </>
        </Grid>
      </Grid>
    )
  }
}

EnterpriseManagerSSO.propTypes = {
}

function mapStateToProps (state) {
  return {
    enterprise: state.enterprise,
    domains: state.enterprise.EnterpriseDomains,
    self: state.self
  }
}

const EnterpriseManagerSSOComponent = withStyles(styles)(EnterpriseManagerSSO)

export default connect(mapStateToProps, { updateSSOForEnterpriseDomain, fetchRemoteMetadataForDomain, forceSamlOnEnterpriseUsers })(EnterpriseManagerSSOComponent)
